import React from 'react'
import { NavLink } from 'react-router-dom'
import {BrokenLink} from 'components/vectors'

const PageNotFound = () => (

    <div className="row mx-0 page-not-found">
        <div className="page-not-found_container">
            <BrokenLink />
            <h3 className="text--md text--black mt-5">Ooops!, Page not found</h3>
            <p className="text--small-light text--grey text-center my-2">We can’t seem to find the page you’re looking for </p>
            <NavLink to="/"><div className="box box--secondary px-4  mt-3">BACK TO HOMEPAGE</div> </NavLink>
        </div>
    </div>

)

export default PageNotFound;